<script>
  const list = [
    {
      title: "FATCAについて",
      linkList: [
        {
          text: "FATCAのご案内",
          url: "FATCAのご案内.pdf"
        }
      ]
    },
    {
      title: "FATCA関連書類",
      linkList: [
        {
          text: "実質的支配者の確認書",
          url: "実質的支配者の確認書.pdf"
        },
        {
          text: "自己宣誓書",
          url: "自己宣誓書.pdf"
        },
        {
          text: "FATCAに関する同意書",
          url: "FATCAに関する同意書.pdf"
        }
      ]
    },
    {
      title: "後納郵便宛名",
      linkList: [
        {
          text: "後納郵便宛名",
          url: "宛名ラベル.pdf"
        }
      ],
      annotation: [
        {
          text: "郵便料金は銀行が負担します。切手を貼る必要はありません。"
        }
      ]
    }
  ]
</script>

<div class="owd-biz-graycontents documents-section">
  {#each list as item, index}
  <div class="documents-item">
    <div class="documents-item-numarea">
      <div class="owd-biz-number:circle">
        <p class="owd-biz-number-text"><strong>{index + 1}</strong></p>
      </div>
      <p class="documents-item-numarea-title">{item.title}</p>
    </div>
    <ul class={item.annotation ? "documents-item-list spacing:bottom:16" : "documents-item-list"} >
      {#each item.linkList as link}
      <li class="owd-text:02"><strong><a href="https://www.minna-no-ginko.com/assets/pdf/business/{link.url}" target="_blank" class="owd-textlink:pdf">{link.text}</a></strong></li>
      {/each}
    </ul>
    {#if item.annotation}
    <ul class="owd-list:annotation">
      {#each item.annotation as ann}
      <li>
        {ann.text}
      </li>
      {/each}
    </ul>
    {/if}
  </div>
  {/each}
</div>

<style lang="scss">
.documents{
  &-item{
    max-width: 1040px;
    &-numarea{
      margin-bottom: 24px;
      display: grid;
      gap: 8px;
      grid-template-columns: 32px 1fr;
      align-items: center;
      &-title{
        @include g.owd-typography($fz: 'heading-2', $line-height-px: 40, $letter-spacing-tracking: 25, $font-weight: 600);
        padding: 2.5px 0;
      }
    }
    &-list{
      display: grid;
      gap: 16px;
      grid-template-columns: 1fr;
    }
  }
  @include g.mobile () {
    &-item{
      &-numarea{
        grid-template-columns: 24px 1fr;
        &-title{
          @include g.owd-typography($fz: 'heading-3', $line-height-px: 40, $letter-spacing-tracking: 25, $font-weight: 600);
          padding: 2px 0;
        }
      }
    }
  }
}
</style>
